var spin360Interval = carouselInterval = '';


const SPACEBAR_KEY_CODE = [0,32];
const ENTER_KEY_CODE = 13;
const ESCAPE_KEY_CODE = 27;


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

document.querySelectorAll('[id^="footer-block-"] h2, [id^="footer-block-"] h6').forEach((ul) => {
  ul.setAttribute('role', 'button');
  ul.setAttribute('aria-expanded', ul.parentNode.hasAttribute('open'));

  if (ul.nextElementSibling?.getAttribute('id')) {
    ul.setAttribute('aria-controls', ul.nextElementSibling.id);
  }

  ul.addEventListener('click', (event) => {
    const openDetailsElement = event.target.closest('.footer-block--menu[open]');

    if (!openDetailsElement) {
      event.target.closest('.footer-block--menu').setAttribute('open', '');
      ul.setAttribute('aria-expanded', true);
    } else {
      const ulElement = openDetailsElement.querySelector('h2');
      openDetailsElement.removeAttribute('open');
      ulElement.setAttribute('aria-expanded', false);
    }
  });
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

class FreqSelector extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelector('.rc_select__frequency').addEventListener('change', this.ChangeFrequencySelector.bind(this));
  }

  ChangeFrequencySelector(event) {
    event.preventDefault();
    this.dispatchEvent(this.changeEvent);
  }
}

customElements.define('frequency-selector', FreqSelector);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function getConfig(type = 'json') {
  return {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    // this.header = this.header || document.getElementById('shopify-section-header');
    this.header = document.querySelector('.grg-section-header');
    console.log('this.header', this.header)
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    //It’s equivalent to: document.querySelector('html')
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);



class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );

    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);

  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

// this is from the old modal language and region selector
// might remove this in the future
// customElements.define('modal-dialog', ModalDialog);



class CountrySelector extends HTMLElement {
  constructor() {
    super();

      this.redirectDomains = {
        'us': 'https://pmdbeauty.com',
        'au': 'https://au.pmdbeauty.com',
        'gb': 'https://uk.pmdbeauty.com',
        'eu': 'https://eu.pmdbeauty.com',
        'ca': 'https://ca.pmdbeauty.com',
        'it': 'https://pmdbeauty.it',
        'kr': 'https://www.pmdbeauty.co.kr'
      };

      //this.selectedCountry = '';
      //console.log('fullURL', new URL(window.location.href))
  }

  connectedCallback() {
    //this.dataLocalization = this.dataset.localizationIsoCode
    this.currentMarketHandle = this.dataset.localizationMarketHandle
    this.detailsElement = this.querySelector('.grg-dropdown-country-switch-wrapper')
    this.currentCountry = this.querySelector('.grg-selected-country-indicator')
    this.countryOptions = this.querySelectorAll('.quick_country_selector_grg > li')

    // invoke the detailsOpener and it will still pass the event object
    this.detailsElement.addEventListener('click', this.detailsOpener.bind(this))
    //we have a helper method that is reponsible for listening clicks outside of our detailsElement
    // the idea is close the detailsElement when clicked from outside
    // we bind this method and assign it to this.handleOutsideClick property 
    // so we have one reference of the this.handleOutsideClick method
    this.handleOutsideClick = this.handleOutsideClick.bind(this)


    // add event listeners to all country bubbles
    this.countryOptions.forEach(option => {
      option.addEventListener('click', () => {
        const selected = option.dataset.alpha
        
        // 🚫 If user selects the same market, do nothing
        if (selected === this.currentMarket) {
          return
        }

        // ✅ Otherwise proceed
        //this.selectedCountry = selected
        this.displayCurrentCountry(selected);
        this.changeRegion.bind(this)(selected);
      })
    })

  }

  // remember;
  // JavaScript removes an event listener only if:
  // the event type matches
  // the target matches
  // the function reference is the exact same function object that was originally added

  detailsOpener(e) {
    // the value will toggle between true or false
    //this will open and close the detailsElement
    this.detailsElement.open = !this.detailsElement.open

    // now if the detailsElement is open we add an event listener for clicks outside this element
    // and remove the listener once the detailsElement is closed
    if (this.detailsElement.open) {
      document.addEventListener('click', this.handleOutsideClick)
    } else {
      // now this removeEventListener handles removal for when detailsOpener method is invoked
      // the detailsElement is toggled open and close
      // the outside listener is added and removed
      document.removeEventListener('click', this.handleOutsideClick)
    }
  }

  handleOutsideClick(e) {
    // If click is outside the <details>, close it
    // meaning this part handles the removal when user clicks OUTSIDE of the details element
    // so there are 2 areas where to remove the eventListener is needed
    if (!this.detailsElement.contains(e.target)) { // basically if the target clicked is not part of the this.detailsElement then close it and removeEventListener
      this.detailsElement.open = false
      document.removeEventListener('click', this.handleOutsideClick)
    }
  }

  displayCurrentCountry(countryCode) {
    const newClass = `country-flag-${countryCode}`

    // Remove previous flag class if it exists
    if (this.currentCountry.dataset.flagClass) {
      this.currentCountry.classList.remove(this.currentCountry.dataset.flagClass)
    }

    // Add new flag class
    this.currentCountry.classList.add(newClass)

    // Store it for next time
    this.currentCountry.dataset.flagClass = newClass
  }

  changeRegion(country) {
    // Prevent redirect if user selects the current market
    //selected === this.currentMarket
    console.log('change region country', country)
    console.log('change region this.currentMarket', this.currentMarket)
    if (country === this.currentMarket) return;

    const baseUrl = this.redirectDomains[country];
    // if the base url cannot be found in the redirect url then do not redirect
    if (!baseUrl) return;

    const { pathname, search, hash } = window.location;

    // Build the full redirect URL and add &stayRegion=1 in order to stay in the selected market or site
    const redirectUrl = `${baseUrl}${pathname}?stayRegion=1`;

    window.location.href = redirectUrl;

  }


}

customElements.define('country-selector', CountrySelector);



class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    //what slides are currently showing? -> store them in the  this.sliderItemsToShow
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;

    //measuring the width of each slide?
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    //counting how many slider by the width of the whole slide minus width of each slide
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);

    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }
    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next'
      ? this.slider.scrollLeft + (step * this.sliderItemOffset)
      : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}


// if (!document.querySelector('.main-product-gallery')) {
//   customElements.define('slider-component', SliderComponent);
//   console.log("we have slider-component")
// }

//let us try removing this part from if statement for now
customElements.define('slider-component', SliderComponent);


class MenuCarousel extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = true;
  }
}

customElements.define('menu-carousel', MenuCarousel);

class SliderComponentWithDots extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    //tweaking the next and prev buttons to accomodate multiple buttons
    //this.prevButton = this.querySelector('button[name="previous"]');
    //this.nextButton = this.querySelector('button[name="next"]');
    this.prevButton = this.querySelectorAll('button[name="previous"]');
    this.nextButton = this.querySelectorAll('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.desktopColumns = this.querySelector('input[id="desktop_columns"]');
    this.mobileColumns = this.querySelector('input[id="mobile_columns"]');
    this.showDesktopSlider = this.showMobileSlider = false;

    if (window.innerWidth >= 767) {
      this.showDesktopSlider = true;
      if (this.desktopColumns) {
        this.slidesPerPage = this.desktopColumns.value;
      }
      var mobileSlideshow = this.querySelector('.mobile_slideshow');
      if (mobileSlideshow) {
        mobileSlideshow.remove();
      }
      this.slider.classList.remove('slider--mobile');
    } else {
      this.showMobileSlider = true;
      this.slidesPerPage = this.mobileColumns.value;
      var desktopSlideshow = this.querySelector('.desktop_slideshow');
      if (desktopSlideshow) {
        desktopSlideshow.remove();
      }
      this.slider.classList.remove('slider--desktop');
    }

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    //tweaking the prev and next button to accomodate multiple buttons
    //this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.prevButton.forEach( button => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    })
    //this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.forEach( button => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    })

    this.sliderControlWrapper = this.querySelector('.slider-buttons');

    if (!this.sliderControlWrapper) return;
    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');


    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
  }

  initPages() {

    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.slidesPerPage = parseInt(this.slidesPerPage);
    if (this.sliderItemsToShow[this.slidesPerPage]) {
      this.sliderItemOffset = this.sliderItemsToShow[this.slidesPerPage].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    }

    if (this.showMobileSlider) {
      this.totalPages = this.sliderItemsToShow.length;
    }
    if (this.showDesktopSlider) {
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage;
    }
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      //this.prevButton.setAttribute('disabled', 'disabled');
      this.prevButton.forEach(button => {
        button.setAttribute('disabled', 'disabled');
      })
    } else {
      //this.prevButton.removeAttribute('disabled');
      this.prevButton.forEach(button => {
        button.removeAttribute('disabled');
      })
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      //this.nextButton.setAttribute('disabled', 'disabled');
      this.nextButton.forEach(button => {
        button.setAttribute('disabled', 'disabled');
      })
    } else {
      //this.nextButton.removeAttribute('disabled');
      this.nextButton.forEach(button => {
        button.removeAttribute('disabled');
      })
    }

    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    //this.prevButton.removeAttribute('disabled');
    this.prevButton.forEach(button => {
      button.removeAttribute('disabled');
    })
    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    if (this.currentPage >= 1) {
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.slider.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

/* end here slider-component-with- */

customElements.define('slider-component-with-dots', SliderComponentWithDots);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    this.updateOptions();
    this.updateMasterId();
    var mediaList = document.querySelector('.main-product__product__media-list');
    if(mediaList) {
      mediaList.classList.remove('loading-skeleton');
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    if (this.currentVariant) {
      var variantOptionSelected = document.querySelector('.variant-options__selected');
      if (variantOptionSelected) {
        variantOptionSelected.innerHTML = this.currentVariant.title;
      }
      var colorName = this.currentVariant.title.toLowerCase();
      //to show color border above main image in product detail page
      colorName = colorName.split(' ').join('-');
      var productColorHeading = document.querySelector('.product-color-heading');
      if (productColorHeading) {
        productColorHeading.style.backgroundColor = 'var(--color-product-' + colorName + ')';
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    });
    var mediaList = document.querySelector('.main-product__product__media-list');
    if(mediaList) {
      //mediaList.classList.add('loading-skeleton1');
    }
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
    loadProductCarousel();
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    if (productForms) {
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[data-productid]');
        if (input) {
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }

      });
    }
    var pageLoad = this.getAttribute('data-page-load');
    if (pageLoad && pageLoad == 'true') {
      location.reload();
    }
    // location.reload();
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    var getFromProductUrl = this.getAttribute('data-product-url');
    if (getFromProductUrl && getFromProductUrl == 'true') {
      var fetchUrl = `${this.dataset.url}?variant=${this.currentVariant.id}`;
    } else {
      var fetchUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`;
    }
    fetch(fetchUrl)
      .then((response) => response.text())
      .then((responseText) => {
        var mediaList = document.querySelector('.main-product__product__media-list');
        if(mediaList) {
          mediaList.classList.remove('loading-skeleton');
        }
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        const btnDestination = document.getElementById(`btn-price-${this.dataset.section}`);
        const btnSource = html.getElementById(`btn-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (btnSource && btnDestination) btnDestination.innerHTML = btnSource.innerHTML;

        //for slider products like gift-cards
        const sliderSource = html.querySelector('[id^="btn-price-"]');
        const sliderDestination = document.querySelector(`.slider-price-${this.dataset.section}`);
        if (sliderSource && sliderDestination) sliderDestination.innerHTML = sliderSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        const btnPrice = document.getElementById(`btn-price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        if (btnPrice) btnPrice.classList.remove('visibility-hidden');


        var link = document.querySelector(`#title-${this.dataset.section}` + ' a');
        var cardImageLink = document.querySelector(`#imageLink-${this.dataset.section}`);
        if (this.currentVariant.id) {
          if (link) {
            link.href = `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`;
          }
          if (cardImageLink) {
            cardImageLink.href = `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`;
          }
        }
        var mediaList = document.querySelector('.main-product__product__media-list');
        if(mediaList) {
          mediaList.classList.remove('loading-skeleton');
        }
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const btnPrice = document.getElementById(`btn-price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (btnPrice) btnPrice.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.variantType = this.getAttribute('data-variant-type');
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    var mediaList = document.querySelector('.main-product__product__media-list');
    if(mediaList) {
      //mediaList.classList.add('loading-skeleton1');
    }
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    var variantSelectsDropdown = document.querySelector('variant-selects-dropdown[data-section="' + `${this.dataset.section}` + '"]');
    if (variantSelectsDropdown && (this.options.length > 0)) {
      var select = variantSelectsDropdown.querySelector('select[data-variant-type="' + this.variantType + '"]');
      if (select) {
        select.value = this.options[0];
        select.dispatchEvent(new Event('change'));
        // select.dispatchEvent(new Event('change',{ bubbles: true }));//to trigger onchange funcitonality
      }
    }
  }
}

customElements.define('variant-radios', VariantRadios);

class ColorSwatchRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    this.optionsSet = Array.from(this.querySelector('fieldset').querySelectorAll('input')).find((radio) => radio.checked);
    this.options = (typeof this.optionsSet == 'undefined') ? '' : this.optionsSet.value;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      if (variant.id == this.options) {
        return variant.id;
      }
    });
  }

  updatePickupAvailability() { }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
  }

  updateShareUrl() { }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`slider-price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`slider-price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  updateVariantInput() {
    document.querySelectorAll(`#product-form-${this.dataset.section}`).forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    const currentVariantInput = this.querySelector('fieldset input[value="' + this.currentVariant.id + '"]');
    if (currentVariantInput) {
      var priceItem = document.querySelector(`.slider-price-${this.dataset.section} .price-item`);
      if (priceItem) {
        priceItem.innerHTML = currentVariantInput.getAttribute('data-prices');
      }

      var link = document.querySelector(`#title-${this.dataset.section}` + ' a');
      var cardImageLink = document.querySelector(`#imageLink-${this.dataset.section}`);
      if (link) {
        link.href = currentVariantInput.getAttribute('data-variantUrl');
      }
      if (cardImageLink) {
        cardImageLink.href = currentVariantInput.getAttribute('data-variantUrl');
      }

      var img = document.querySelector(`.slider-media-${this.dataset.section} img`);
      if (img) {
        img.srcset = currentVariantInput.getAttribute('data-img');
      }
    }
  }
}

customElements.define('color-swatch-radios', ColorSwatchRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class IframeVideoPlayPause extends HTMLElement {
  constructor() {
    super();
    // this.querySelector('.video-overlay').addEventListener('click', this.pauseVideo.bind(this));
    // this.iframe = this.querySelector('.iframe-container iframe');
    // this.type = this.getAttribute('data-type');
    // this.playButton = this.querySelector('.video-section__control-button');
    // if(!this.iframe.hasAttribute('src')) this.iframe.setAttribute('src', this.iframe.dataset.src);
    // if (this.type == "vimeo") {
    //   this.player = new Vimeo.Player(this.iframe);
    //   if (this.player && this.playButton) {
    //     this.playButton.addEventListener('click', this.clickVimeoButton.bind(this));
    //   }
    // } else {

    //   this.playButton.addEventListener('click', this.clickYoutubeButton.bind(this));
    // }

    this.type = this.getAttribute('data-type');
    this.playButton = null;
    this.overlay = null;
    this.iframe = null;
    this.player = null;

  }

  connectedCallback() {
    this.playButton = this.querySelector('.video-section__control-button');
    this.overlay = this.querySelector('.video-overlay');

    this.initLazyload();
  }

  disconnectedCallback() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  }

  initLazyload() {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          //console.log('iframe intersecting')
          this.injectIframeFromTemplate();
          obs.unobserve(this);
        }
      });
    });
    observer.observe(this);
  }

  injectIframeFromTemplate() {
    const template = this.querySelector('template');
    //console.log('template', template)
    if (!template) return;

    const iframe = template.content.firstElementChild.cloneNode(true);
    iframe.setAttribute('src', iframe.dataset.src); // activate lazyload
    this.querySelector('.iframe-container').appendChild(iframe);
    this.iframe = iframe;

    if (this.type === "vimeo") {
      this.player = new Vimeo.Player(this.iframe);
      if(this.player) {
        this.playButton?.addEventListener('click', this.clickVimeoButton.bind(this));
      }
    } else {
      if(this.player) {
        this.playButton?.addEventListener('click', this.clickYoutubeButton.bind(this));
      }
    }

    this.overlay?.addEventListener('click', this.pauseVideo.bind(this));
  }

  pauseVideo(e) {
    if (this.playButton.classList.contains('pause')) {
      if (this.type == "vimeo") {
        if (!this.player.paused) {
          this.player.pause();
          this.changeButtonStatus('play');
        }
      } else {
        this.iframe.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        this.changeButtonStatus('play');
      }
    }
  }
  changeButtonStatus(status) {
    if (status == 'play') {
      this.playButton.classList.remove('pause');
      this.playButton.classList.add('play');
      this.playButton.setAttribute('title', 'Play video');
      if(this.playButton.hasAttribute('aria-label')) {
        this.playButton.setAttribute('aria-label', 'Play video');
      }
    } else {
      this.playButton.classList.remove('play');
      this.playButton.classList.add('pause');
      this.playButton.setAttribute('title', 'Pause video');
      if(this.playButton.hasAttribute('aria-label')) {
        this.playButton.setAttribute('aria-label', 'Pause video');
      }
    }
  }
  clickYoutubeButton(e) {
    e.preventDefault();
    if (e.target.classList.contains('play')) {
      this.iframe.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
      this.changeButtonStatus('pause');
    } else {
      this.iframe.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      this.changeButtonStatus('play');
    }
  }
  clickVimeoButton(e) {
    var parent = this;
    if (e.target.classList.contains('play')) {
      this.player.getPaused().then(function (paused) {
        // `paused` indicates whether the player is paused
        parent.player.play().then(function () {
          parent.changeButtonStatus('pause');
        }).catch(function (error) {
          if (!parent.player.paused) {
            parent.changeButtonStatus('pause');
          }
        });
      });
    } else {
      this.player.pause();
      this.changeButtonStatus('play');
    }
  }
}
customElements.define('iframe-video-play-pause', IframeVideoPlayPause);
class VideoPlay extends HTMLElement {
  constructor() {
    super();
    const videoPlayer = this.querySelector('.video--playing');
    this.querySelector('.video-overlay').addEventListener('click', this.pauseVideo.bind(this));
    this.video = this.querySelector('.video');
    this.playButton = videoPlayer.querySelector('.video-section__control-button');
    this.playButton.addEventListener('click', this.playPauseVideo.bind(this));
  }
  playPauseVideo(e) {
    if (this.video.paused) {
      this.video.play();
      this.playButton.classList.remove('play');
      this.playButton.classList.add('pause');
      this.playButton.setAttribute('title', 'Pause video');
      if(this.playButton.hasAttribute('aria-label')) {
        this.playButton.setAttribute('aria-label', 'Pause video');
      }
    } else {
      this.video.pause();
      this.playButton.classList.remove('pause');
      this.playButton.classList.add('play');
      this.playButton.removeAttribute('title', 'Pause video');
    }
  }
  pauseVideo(e) {
    if (!this.video.paused) {
      this.video.pause();
      this.playButton.classList.remove('pause');
      this.playButton.classList.add('play');
      this.playButton.setAttribute('title', 'Play video');
      if(this.playButton.hasAttribute('aria-label')) {
        this.playButton.setAttribute('aria-label', 'Play video');
      }
    }
  }
}
customElements.define('video-play', VideoPlay);

// class YotpoRating extends HTMLElement {
//   constructor() {
//     super();
//   }
//   checkYotpo() {
//     var mainYotpo = this.querySelector('.main-yotpo');
//     if (mainYotpo) {
//       if (mainYotpo.querySelector('.standalone-bottomline')) {
//         var i = 1;
//         var reviewsText = mainYotpo.querySelector('a.text-m');
//         if (reviewsText) {
//           reviewsText.remove();
//         }
//         var ratingText = mainYotpo.querySelector('.sr-only');
//         if (ratingText) {
//           ratingText = ratingText.innerHTML;;
//           ratingText = ratingText.replace(' star rating', '');
//           mainYotpo.querySelector('.sr-only').innerHTML = ratingText;
//           mainYotpo.parentElement.style.display = 'block';
//           clearInterval(this.gotYotpo);
//         }
//       } else {
//         clearInterval(this.gotYotpo);
//       }
//     }
//   }
//   connectedCallback() {
//     this.style.display = 'none';
//     this.gotYotpo = setInterval(this.checkYotpo.bind(this), 700);
//   }
// }
// customElements.define('yotpo-rating', YotpoRating);


const checkCompDescHeight = () => {
  let compare_slider_card__text_height = 0;
  let compare_slider_card__text = document.querySelectorAll('.compare-slider-card__info__text');
  if (compare_slider_card__text) {
    compare_slider_card__text.forEach((e) => {
      e.style.height = "unset";
      compare_slider_card__text_height = e.clientHeight >= compare_slider_card__text_height ? e.clientHeight : compare_slider_card__text_height;
    });
    compare_slider_card__text.forEach((elem) => {
      elem.style.height = `${compare_slider_card__text_height}px`;
    });
  }
}
checkCompDescHeight();
window.addEventListener("resize", () => {
  checkCompDescHeight();
});

(function () {
  document.querySelectorAll('.js-search-toggle').forEach(element => {
    element.setAttribute('aria-haspopup', 'dialog');
  });

  // Opens the Globo plugin search box.
  document.addEventListener('click', function (event) {
    var targetElement = event.target.closest('.js-search-toggle');

    if (targetElement) {
      event.preventDefault();

      // Globo Search only detects when a search input is focused.
      // Create a dummy search input element that we'll focus and remove later.
      var searchInput = document.createElement('input');
      searchInput.type = 'search';
      searchInput.name = 'q';
      searchInput.classList.add('search__input', 'field__input');

      targetElement.appendChild(searchInput);
      searchInput.focus();

      // Removes the dummy search input almost immediately.
      setTimeout(function () {
        targetElement.removeChild(searchInput);
      }, 10);
    }
  });
})();
/**************carousel for product page gallery start*************************/
const elementInViewport = (el) => {
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;

  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top >= window.pageYOffset &&
    left >= window.pageXOffset &&
    (top + height) <= (window.pageYOffset + window.innerHeight) &&
    (left + width) <= (window.pageXOffset + window.innerWidth)
  );
}
function carouselSlideClick(event) {
  const liCount = event.currentTarget.getAttribute('data-count');
  const mainProductGallery = document.querySelector('.main-product-gallery');
  if (mainProductGallery) {
    let shouldSkip = false;
    mainProductGallery.querySelectorAll('li').forEach((li, index) => {
      if (shouldSkip) {
        return;
      }
      if (index + 1 == parseInt(liCount)) {
        // li.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        li.scrollIntoView({ block: "center" });
        shouldSkip = true;
        return false;
      }
    });
  }
}
const checkGalleryModal = () => {
  const productModal = document.querySelector('product-modal.spinstudio-holder')
  if(productModal) {
    if(productModal.querySelector('img')) {
      productModal.querySelectorAll('img').forEach(img => {
        img.classList.remove('spinstudio-hidden');
      });
    }
    clearInterval(spin360Interval);
  }
}

const loadSpinBtn = () => {
  const isModal360Opener = document.querySelector('.modal-360-opener');
  if(isModal360Opener) {
    if(isModal360Opener.getAttribute('data-tags') == 'spin-modal') {
      spin360Interval = setInterval(checkGalleryModal, 1000);
    }
    const spinModalOpener = document.querySelectorAll('.modal-360-opener');
    spinModalOpener.forEach(btn => {
      if(btn.getAttribute('data-tags') == 'spin-modal') {
        document.querySelector('.show-product-360-title').classList.remove('visually-hidden');
        btn.addEventListener('click', function() {
          const spinModal = document.querySelector(this.getAttribute('data-modal'));
          if (spinModal) spinModal.show(btn);
        });
      }
    });
  }
}
function intersectionHandler(entry) {
  const mainProductGallery = document.querySelector('.main-product-gallery');
  const index = [...mainProductGallery.childNodes].findIndex(item => item === entry.target)
  document.querySelector('.images-indicator-item.active')?.classList.remove('active');
  const divs = document.querySelectorAll('.images-indicator-item');
  if (divs[index]) {
    divs[index].classList.add('active');
  }
}
let minId = null;
let maxId = null;
let debounceTimeout = null;

function applyChanges() {
  if(minId != null && maxId != null) {
    document.querySelector('.images-indicator-item.active')?.classList.remove('active');
    const divs = document.querySelectorAll('.images-indicator-item');
    if(minId == 0) {
      if (divs[minId]) {
        divs[minId].classList.add('active');
      }
    } else {
      if (divs[maxId]) {
        divs[maxId].classList.add('active');
      }
    }
  }
  // perform action on elements with Id between min and max
  minId = null;
  maxId = null;
}
const loadVariantCarousel = () => {
  const mainProductGallery = document.querySelector('.main-product-gallery');
  if (mainProductGallery) {
    const allLi = mainProductGallery.querySelectorAll('li');
    var indicatorBox = document.querySelector('.images-indicator-box');
    if (indicatorBox) {
      indicatorBox.classList.remove('visually-hidden');
      var newLi = '';
      for (var i = 1; i <= allLi.length; i++) {
        if(allLi.length > 1) {
          var addClass = (i == 1) ? 'active' : '';
        } else {
          var addClass = 'visually-hidden';
        }
        newLi += '<li class="images-indicator-item ' + addClass + '" data-count=' + i + ' </li>';
      }
      indicatorBox.querySelector('.images-indicator-list').innerHTML = newLi;
      indicatorBox.querySelectorAll('.images-indicator-list li').forEach(li => {
        li.addEventListener('click', carouselSlideClick.bind(this));
      });
      /******************************* */
      const config = {
        // rootMargin: '-50px 0px -55%',
        threshold: [1]
      };
      let observer = new IntersectionObserver(function (entries, self) {
        clearTimeout(debounceTimeout);
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const entryId = parseInt(entry.target.getAttribute('data-pos'));
            if (minId === null || maxId === null) {
              minId = entryId;
              maxId = entryId;
            } else {
              minId = Math.min(minId, entryId);
              maxId = Math.max(maxId, entryId);
            }
            intersectionHandler(entry);
          }
        });
        debounceTimeout = setTimeout(applyChanges, 500);
      }, config);
      let idCounter = 0;

      allLi.forEach(li => {
        li.setAttribute('data-pos', idCounter++);
        observer.observe(li);
      });
      /******************************************/
      indicatorBox.querySelector('.indicator-btn--up')?.addEventListener('click', carouselUpBtnClick.bind(this));
      indicatorBox.querySelector('.indicator-btn--down')?.addEventListener('click', carouselDownBtnClick.bind(this));
      mainProductGallery.parentElement.querySelectorAll('.slider-button').forEach((elm) => {
        if(elm.classList.contains('spiceFeatPrev') || elm.classList.contains('spiceFeatNext')) {
          // elm.remove();
        }
      });
      if(customElements.get('slider-component') === undefined)
        customElements.define('slider-component', SliderComponent);
      else  {
        const sliderNextBtn = mainProductGallery.parentElement.querySelector('.slider-button.slider-button--next');
        //in case of changing product variant, default slider is making next arrow disabled
        if(sliderNextBtn) {
          setTimeout(function() {
            if(sliderNextBtn.hasAttribute('disabled')) {
              sliderNextBtn.removeAttribute('disabled')
            }
          },2500);
        }
      }
    }
  }
}
const loadCarousel = () => {
  //loadcarousel in media gallery in product detail page when classlist will have spiceFeat class
  if (document.querySelector('.main-product-gallery').classList.contains('spiceFeat')) {
    loadSpinBtn();
    loadVariantCarousel();
    const rcContainer = document.querySelector('#rc_container');
    if(!rcContainer || (rcContainer && rcContainer.innerHTML == '')) {
      if(document.querySelector('afterpay-placement')) {
        document.querySelector('afterpay-placement').style.display = 'block';
      }
    }
    clearInterval(carouselInterval);
  }
}

function loadProductCarousel() {
  setTimeout(function () {
    window.scrollTo(0, 0);
  }, 10);
  if (document.querySelector('.main-product-gallery')) {
    if(document.querySelector('variant-radios') || document.querySelector('variant-selects')) {
      carouselInterval = setInterval(loadCarousel, 1000);
    } else {
      loadSpinBtn();
      loadVariantCarousel();
    }
  }
}

function carouselUpBtnClick(event) {
  var activeLiCount = event.currentTarget.parentElement.querySelector('.images-indicator-item.active').getAttribute('data-count');
  activeLiCount = parseInt(activeLiCount);
  if (activeLiCount > 1) {
    event.currentTarget.parentElement.querySelector(`.images-indicator-item[data-count="${activeLiCount - 1}"]`)?.click();
  }
}
function carouselDownBtnClick(event) {
  const mainProductGallery = document.querySelector('.main-product-gallery');
  if (mainProductGallery) {
    const allLi = mainProductGallery.querySelectorAll('li');
    var activeLiCount = event.currentTarget.parentElement.querySelector('.images-indicator-item.active').getAttribute('data-count');
    activeLiCount = parseInt(activeLiCount);
    if (activeLiCount < allLi.length) {
      event.currentTarget.parentElement.querySelector(`.images-indicator-item[data-count="${activeLiCount + parseInt(1)}"]`)?.click();
    }
  }

}
var lastScrollTop = 0;
/*window.addEventListener('scroll', () => {
  const mainProductGallery = document.querySelector('.main-product-gallery');
  if (mainProductGallery) {
    const allLi = mainProductGallery.querySelectorAll('li');
    for (let i = 0; i < allLi.length; ++i) {
      const isElementInViewport = elementInViewport(allLi[i]);
      if (isElementInViewport) {
        document.querySelector('.images-indicator-item.active')?.classList.remove('active');
        const divs = document.querySelectorAll('.images-indicator-item');
        if (divs[i]) {
          divs[i].classList.add('active');
        }
        break;
      }
    }
  }
});*/
/**************carousel for product page gallery end*************************/
if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      if(thumbnail) {
        this.setActiveThumbnail(thumbnail);
      }
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      //commenting out the below code for now because it's causing error with the isSlideVisible function
      //for some reason, the THIS keyword has no access to the isSlideVisible method
      //if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
      //this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
class AnnouncementDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.triggers = document.querySelectorAll('.js-open-announcement-drawer');
  }
  
  connectedCallback() {
    // Register the click event on the trigger.
    this.triggers.forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.open(this.trigger);
      });
    });
  
    // This adds extra space to the bottom of the body so that mobile users can see the footer links.
    const spacerElement = document.createElement('div');
    spacerElement.classList.add('mobile-only');
    spacerElement.style.height = '72px';
    spacerElement.innerHTML = '&nbsp;';
    document.body.appendChild(spacerElement);


    //moved the code to product form since it looks like it's the last code to execute
  //   window.onload = function() {
  //     const queryString = window.location.search;
  //     if(queryString) {
  //         const urlParams = new URLSearchParams(queryString);
  //         const scrollTo = urlParams.get('scrollTo')
  //         if(scrollTo) {
  //             setTimeout(()=> {
  //               const element = document.getElementById(scrollTo)
  //               if(element) {
  //                 element.scrollIntoView({behavior: 'smooth', block: 'center'});
  //               }
  //             }, 100)
  //         }
  //     }

  // };
  }
  
  open(triggeredBy) {
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});
  
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = document.getElementById('AnnouncementDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
  }
  
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
  }
}
  
if (!customElements.get('announcement-drawer')) {
  customElements.define('announcement-drawer', AnnouncementDrawer);
}
if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);




/**************Script for our PDP Animate in to View START GRG *************************/

const observeElements = document.querySelectorAll('.grg-observe-me-true')

const options = {
  root: null,
  threshold: 0,
  rootMargin: "300px -50px -200px -50px"
}


if (observeElements) {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        entry.target.classList.add('is-intersecting')
      }

      if(!entry.isIntersecting) {
        entry.target.classList.remove('is-intersecting')
        //entry.target.classList.remove('')
      }

    })

  }, options)


  observeElements.forEach(element => {
    observer.observe(element);
  })
  

}

/**************Script for our PDP Animate in to View END GRG *************************/


/************** GRG Object Oriented Scripts Start *************************/

// GRG script for CTA & Sliding Cards
// link to this code https://www.youtube.com/watch?v=6QE8dXq9SOE
class GrgSliderCard extends HTMLElement {
  constructor() {
    super()

    //the below is how to Declaring Multiple Variables in a Single Line sing a comma-separated list with let
    //this.isDragging = false, startX, startScrollLeft, timeoutId;

    this.isDragging = false;
    this.startX;
    this.startScrollLeft;
    this.timeoutId;

    this.mainSection = document.querySelector(".collection.slider-steps-section")
    this.wrapper = this.querySelector(".grg-slider-card__wrapper")
    this.carousel =  this.querySelector(".grg-slider-card__carousel")
    this.arrowBtns = this.querySelectorAll(".grg-slider-card__wrapper i")
    this.firstCardWidth = this.carousel.querySelector(".grg-slider-card__card").offsetWidth;

    //spread syntax or rest parameter >> allows an iterable (like an array or string) to be expanded into individual elements.
    this.carouselChildrens = [...this.carousel.children]

    // Get the number of cards that can fit in the carousel at once
    this.cardPerView = Math.round(this.carousel.offsetWidth / this.firstCardWidth) 
    this.originLeft = this.carousel.scrollLeft

  }

  connectedCallback() {
    // connected callback event hook is where I set all the major event listeners

    
    if(this.carouselChildrens.length > 5) {

      this.carousel.addEventListener("mousedown", this.dragStart.bind(this))
      this.carousel.addEventListener("mousemove", this.dragging.bind(this))
  
  
  
      //this will stop the cards from sliding if the mousedownbutton is release
      document.addEventListener("mouseup", this.dragStop.bind(this))
      this.wrapper.addEventListener("mouseenter", clearTimeout(this.timeoutId))
      this.wrapper.addEventListener("mouseleave", this.autoPlay)

    }


    // add event listeners for the arrow buttons to scroll the carousel left and right
    if(this.arrowBtns) {
      this.arrowBtns.forEach( btn => {
          btn.addEventListener("click", () => {
            this.carousel.scrollLeft += btn.id === "left" ? -this.firstCardWidth: this.firstCardWidth
          })
      })
    }


    //if we want to do the infinite scroll and cards are greater than 5
    if(this.mainSection.dataset.scrollInfinite  == "true" && this.carouselChildrens.length > 5 ) {

        // insert copies of the last few cards to beginning of carousel for infinite scrolling
        // notice the negative value of this.cardPerView?
        // this starts counting from the end of the array extracting the last (this.cardPerView) elements
          this.carouselChildrens.slice(-this.cardPerView).reverse().forEach(card => {
            let listElement = document.createElement("li");
            listElement.classList.add('grg-slider-card__card')
            listElement.classList.add('head')
            listElement.innerHTML = card.innerHTML
            this.carousel.insertAdjacentElement("afterbegin", listElement)
          });

          // insert copies of the first few cards to the end of carousel for infinite scrolling
          this.carouselChildrens.slice(0, this.cardPerView).forEach(card => {
            let listElement = document.createElement("li");
            listElement.classList.add('grg-slider-card__card')
            listElement.classList.add('tail')
            listElement.innerHTML = card.innerHTML
            this.carousel.insertAdjacentElement("beforeend", listElement)
          });

          this.carousel.addEventListener("scroll", this.infiniteScroll.bind(this))

    }


    //this.autoplayGrg()


  }

  autoplayGrg() { // will need to invoke this somewhere if this feature is needed
    if(window.innerWidth < 800) return; // Return if window is smaller than 800
    // autoplay the carousel after every 2500ms
    this.timeoutId = setTimeout(() => this.carousel.scrollLeft += this.firstCardWidth, 2500);
  }

  infiniteScroll() {
    // if the carousel is at the beginning, scroll to the end
    if(this.carousel.scrollLeft === this.originLeft) { // may I add and IF it is infinite scroll
      this.carousel.classList.add("no-transition") // remove the smoot scroll animation in order to look like proper infinite scrolling effect
      this.carousel.scrollLeft = this.carousel.scrollWidth - ( 2 * this.carousel.offsetWidth);
      this.carousel.classList.remove("no-transition")
      
    } 
    // if the carousel is at the end, scroll to the beginning
    else if(Math.ceil(this.carousel.scrollLeft) === this.carousel.scrollWidth - this.carousel.offsetWidth) { // Math.ceil method rounds a number rounded UP to the nearest integer

      this.carousel.classList.add("no-transition") // remove the smoot scroll animation in order to look like proper infinite scrolling effect
      this.carousel.scrollLeft = this.carousel.offsetWidth;
      this.carousel.classList.remove("no-transition")
    }

    //clear existing timeout & start autoplay if mouse is not hovering over carousel
    clearTimeout(this.timeoutId);
    //if(!this.wrapper.matches(":hover")) this.autoplayGrg()
  }

  dragStart(e) {
    this.isDragging = true;
    this.carousel.classList.add("dragging");

    //records the initial cursor and scroll position of the carousel
    this.startX = e.pageX;
    this.startScrollLeft = this.carousel.scrollLeft;
  }

  dragging(e) {
    if(!this.isDragging) return; // if isDragging is false return from here
    //updates the scroll position of the carousel based on the cursor movement
    this.carousel.scrollLeft = this.startScrollLeft - (e.pageX - this.startX);
  }

  dragStop() {
    this.isDragging = false;
    this.carousel.classList.remove("dragging")

  }



  


}

customElements.define('grg-slider-card', GrgSliderCard);

/************** GRG Object Oriented Scripts End *************************/





